import { render } from "./ConsentModal.vue?vue&type=template&id=0e646f6d&scoped=true"
import script from "./ConsentModal.vue?vue&type=script&lang=js"
export * from "./ConsentModal.vue?vue&type=script&lang=js"

import "./ConsentModal.vue?vue&type=style&index=0&id=0e646f6d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e646f6d"]])

export default __exports__